import { render, staticRenderFns } from "./TempAvailabilityMessage.vue?vue&type=template&id=5c23c5b7&scoped=true&"
import script from "./TempAvailabilityMessage.vue?vue&type=script&lang=js&"
export * from "./TempAvailabilityMessage.vue?vue&type=script&lang=js&"
import style0 from "./TempAvailabilityMessage.vue?vue&type=style&index=0&id=5c23c5b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23c5b7",
  null
  
)

export default component.exports